import axios from 'axios'

const api = axios.create({
  baseURL: '/api/v1',
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 120000, // 2 minute timeout for long AI operations
})

// Add token to requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    console.error('Request error:', error.message)
    return Promise.reject(error)
  }
)

// Handle errors with better user feedback
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const status = error.response?.status
    const message = error.response?.data?.error || error.response?.data?.message || error.message
    
    // Handle network errors
    if (!error.response) {
      console.error('Network error:', error.message)
      error.userMessage = 'Network error. Please check your connection and try again.'
      return Promise.reject(error)
    }

    // Handle 401 - token expired or invalid
    if (status === 401) {
      localStorage.removeItem('token')
      const authStorage = localStorage.getItem('auth-storage')
      if (authStorage) {
        try {
          const parsed = JSON.parse(authStorage)
          parsed.state = { user: null, token: null, isAuthenticated: false }
          localStorage.setItem('auth-storage', JSON.stringify(parsed))
        } catch (e) {
          localStorage.removeItem('auth-storage')
        }
      }
      window.location.href = '/login'
      return Promise.reject(error)
    }

    // Handle 403 - forbidden
    if (status === 403) {
      error.userMessage = 'You do not have permission to perform this action.'
      return Promise.reject(error)
    }

    // Handle 404 - not found
    if (status === 404) {
      error.userMessage = 'The requested resource was not found.'
      return Promise.reject(error)
    }

    // Handle 429 - rate limited
    if (status === 429) {
      error.userMessage = 'Too many requests. Please wait a moment and try again.'
      console.warn('Rate limited:', message)
      return Promise.reject(error)
    }

    // Handle 500 - server error
    if (status >= 500) {
      error.userMessage = 'Server error. Please try again later.'
      console.error('Server error:', message)
      return Promise.reject(error)
    }

    // Handle quota errors
    if (message?.includes('quota') || message?.includes('QUOTA')) {
      error.userMessage = 'AI quota exceeded. Please try again later or contact support.'
      return Promise.reject(error)
    }

    // Default error message
    error.userMessage = message || 'An unexpected error occurred.'
    return Promise.reject(error)
  }
)

export default api
